import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {useSelector} from "react-redux";

import {Feedback, LogoYellow, Settings, User} from '../../assets';
import {GeneralLink} from "../../models/Routes";
import {userSelectors} from "../../redux";
import AppSettings from '../../scenes/admin/components/AppSettings';
import FeedbackModal from '../../scenes/frontoffice/components/FeedbackModal';
import {Button, Spinner} from '..';
import { Theme } from '../button/Button';

import './TopBar.scss';

interface Props {
  children?: JSX.Element | JSX.Element[];
}

enum topbarModal {
  SETTINGS = 'SETTINGS',
  FEEDBACK = 'FEEDBACK',
}

const TopBar: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const isLogoutLoading = useSelector(userSelectors.isLogoutLoading);
  const userInfo = useSelector(userSelectors.getUserInfo);
  const [openedModal, setOpenedModal] = useState<topbarModal>();

  return (
    <nav className='top-bar'>
      <div className='content'>
        <div className='title'>
          <LogoYellow />
          <p>{t('title')}</p>
        </div>
        <section className='buttons'>
          {children}
          <Button theme={Theme.SECONDARY} onClickCallback={() => setOpenedModal(topbarModal.FEEDBACK)}>
            <Feedback />
            <p>{t('lblFeedback')}</p>
          </Button>
          <div className='divider' />
          <Button theme={Theme.SECONDARY} onClickCallback={() => setOpenedModal(topbarModal.SETTINGS)}>
            <Settings />
            <p>{t('titleSettings')}</p>
          </Button>
          <div className='divider' />
          {!!userInfo && (
            <div className='topbar-link logout-link'>
              <User className='sidebar-icon' />
              <div>
                <a href={GeneralLink.LOGOUT} className=''>
                  {t('lblLogout')}
                </a>
              </div>
              {isLogoutLoading && <Spinner />}
            </div>
          )}
        </section>

        <AppSettings closeModal={() => setOpenedModal(null)} isOpen={openedModal === topbarModal.SETTINGS} />
        <FeedbackModal closeModal={() => setOpenedModal(null)} isOpen={openedModal === topbarModal.FEEDBACK} />
      </div>
    </nav>
  );
};

export default TopBar;
